"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATE = void 0;
exports.STATE = '__STATE__';
//# sourceMappingURL=local-mock.constants.js.map